
import { MetadataDialogComponent, MetadataDialogData } from "../components/metadataDialog/metadata.dialog";
import { ClassMetadata } from "@tylertech/tyler-api-types";
import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

@Injectable()
export class MetadataDialogService
{
    private readonly matDialog = inject(MatDialog);


    show<T>(
        title: string,
        dataMethod: string,
        metadataMethod: string,
        width: number = 80,
        model: any = null,
        metadata: ClassMetadata = null,
        readOnly: boolean = false
    ): Promise<T>
{

        const dialogConfig = <MatDialogConfig<MetadataDialogData>>{
            data: {
                title: title,
                dataMethod: dataMethod,
                metadataMethod: metadataMethod,
                width: width,
                model: model,
                metadata: metadata,
                readOnly: readOnly
            }
        };

        const dialogRef = this.matDialog.open(MetadataDialogComponent, dialogConfig);
        return dialogRef
            .afterClosed()
            .toPromise()
            .catch(_r =>
{
                /* Squashing errors */
            });
    }
}
